import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListDestinationsVariables = Types.Exact<{ [key: string]: never }>;

export type ListDestinations = {
  destinations?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Destination,
          | 'outputId'
          | 'outputType'
          | 'displayName'
          | 'defaultForSeverity'
          | 'alertTypes'
          | 'logTypes'
          | 'allowManualDispatch'
        >
      >
    >
  >;
};

export const ListDestinationsDocument = gql`
  query ListDestinations {
    destinations {
      outputId
      outputType
      displayName
      defaultForSeverity
      alertTypes
      logTypes
      allowManualDispatch
    }
  }
`;

/**
 * __useListDestinations__
 *
 * To run a query within a React component, call `useListDestinations` and pass it any options that fit your needs.
 * When your component renders, `useListDestinations` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDestinations({
 *   variables: {
 *   },
 * });
 */
export function useListDestinations(
  baseOptions?: Apollo.QueryHookOptions<ListDestinations, ListDestinationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDestinations, ListDestinationsVariables>(
    ListDestinationsDocument,
    options,
  );
}
export function useListDestinationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDestinations, ListDestinationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDestinations, ListDestinationsVariables>(
    ListDestinationsDocument,
    options,
  );
}
export function useListDestinationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDestinations, ListDestinationsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDestinations, ListDestinationsVariables>(
    ListDestinationsDocument,
    options,
  );
}
export type ListDestinationsHookResult = ReturnType<typeof useListDestinations>;
export type ListDestinationsLazyQueryHookResult = ReturnType<typeof useListDestinationsLazyQuery>;
export type ListDestinationsSuspenseQueryHookResult = ReturnType<
  typeof useListDestinationsSuspenseQuery
>;
export type ListDestinationsQueryResult = Apollo.QueryResult<
  ListDestinations,
  ListDestinationsVariables
>;
export function mockListDestinations({
  data,
  variables,
  errors,
}: {
  data: ListDestinations;
  variables?: ListDestinationsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: ListDestinationsDocument, variables },
    result: { data, errors },
  };
}
